'use client';

// ============================================================================
// LE SCEAU D'UN UNIVERS : sa marque, en monument, sur son ecran de connexion
// ----------------------------------------------------------------------------
// Sur la porte commune, le prisme tient la scene. Sur l'adresse d'un univers
// (guardinformatique.vyndra.fr), c'est SA marque qui la tient, avec le meme
// traitement que le prisme : le logo net, et sous lui le meme logo, flou, qui
// projette sa couleur sur le fond. Derriere, tres estompe et debordant de la
// page, le filigrane que le dirigeant voulait « derriere completement l'encart
// de connexion ».
//
// QUEL FICHIER. Celui que le dirigeant a choisi pour l'emplacement
// « filigrane » (Reglages > Societes emettrices > Logo et couleurs), prevu pour
// un fond SOMBRE et une forme CARREE : exactement la scene de cet ecran. La
// regle de repli commune (logoPourEmplacement) decide, rien n'est choisi ici.
// Aucun fichier, ou un fichier illisible : il ne reste que le filigrane, jamais
// une image brisee ni une lettre inventee.
// ============================================================================

import { logoPourEmplacement, lireReglagesEmplacements, useImageEnEchec, type JeuLogos } from '@/components/ui/brand-asset';
import { FiligraneMarque } from '@/components/espace/marque-typographie';
import s from './connexion.module.css';

export function SceauUnivers({
  jeu,
  logoEmplacements,
}: {
  jeu: JeuLogos;
  logoEmplacements: unknown;
}) {
  const reglages = lireReglagesEmplacements(logoEmplacements);
  const resolu = logoPourEmplacement(jeu, 'filigrane', reglages);
  const adresse = resolu.inexploitable ? null : resolu.url;
  const { imgRef, enEchec, signalerEchec } = useImageEnEchec(adresse);

  return (
    <div className={s.sceauScene} aria-hidden="true">
      {/* Le filigrane geant, derriere tout. */}
      <div className={s.sceauFiligrane}>
        <FiligraneMarque jeu={jeu} reglagesEmplacements={reglages} taille="100%" opacite={0.07} cadrage="entier" />
      </div>
      {adresse && !enEchec && (
        <div className={s.sceauObjet}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img className={s.sceauLueur} src={adresse} alt="" />
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img ref={imgRef} className={s.sceauNet} src={adresse} alt="" onError={signalerEchec} />
        </div>
      )}
    </div>
  );
}
